import dayjs from "dayjs";
import React from "react";
import {
  ChartComponentProps,
  ChartConfig,
  createChartConfig,
  TimeSeriesDataPoint,
} from "src/components/Referral-partner/Analytics/analyticsTypes";
import { CustomerTradingActivity } from "src/components/Referral-partner/Analytics/charts/CustomerTradingActivity";
import { WarningWrapper } from "src/components/Referral-partner/Analytics/styles/shared.styles";
import api from "src/store/features/api";
import { useRPAnalyticsState } from "src/store/features/RPAnalytics.slice";

const useGetTradingHistoryConfig = (): { tradinghistory: ChartConfig<TimeSeriesDataPoint> } => {
  const { chartDateRange } = useRPAnalyticsState();

  // fetch data and states
  const {
    data: rawTradingHistory,
    isLoading: tradeIsLoading,
    isFetching: tradeIsFetching,
    isError: tradeIsError,
    error: tradeError,
  } = api.useGetReferralTradeHistoryQuery({
    timeFrame: chartDateRange.tradinghistory,
    timezone: dayjs.tz.guess(),
  });

  // format data
  const tradingHistoryData = React.useMemo((): TimeSeriesDataPoint[] => {
    if (!rawTradingHistory) return [];
    return rawTradingHistory.data.filter(
      (trade) =>
        trade["Buy Orders"] !== 0 ||
        trade["Sell Orders"] !== 0 ||
        trade["Target Orders"] !== 0 ||
        trade["Trade Orders"] !== 0,
    );
  }, [rawTradingHistory]);

  // create chart config
  const tradingHistoryConfig = React.useMemo(
    (): { tradinghistory: ChartConfig<TimeSeriesDataPoint> } => ({
      tradinghistory: createChartConfig<TimeSeriesDataPoint>({
        title: "Customer Trading Activity",
        type: "line",
        menuMode: "normal",
        defaultDate: "all time",
        tooltip: "",
        isLoading: tradeIsLoading || tradeIsFetching,
        data: tradingHistoryData,
        component: ({ data }: ChartComponentProps<TimeSeriesDataPoint>): JSX.Element => {
          if (tradeIsError) {
            return <WarningWrapper>{tradeError?.message}</WarningWrapper>;
          } else if (data.length <= 0) {
            return <WarningWrapper color="#002035">No Data</WarningWrapper>;
          } else {
            return <CustomerTradingActivity data={data} />;
          }
        },
      }),
    }),
    [tradingHistoryData, tradeIsLoading, tradeIsFetching, tradeIsError, tradeError],
  );

  return tradingHistoryConfig;
};

export default useGetTradingHistoryConfig;
